export default class ApiStateDoesNotExistError extends Error {
  entityId: string;

  constructor(entityId: string) {
    super(`ApiState doesn't exist for entity with id: ${entityId}`);
    this.entityId = entityId;
  }
}
